{
  "#HARDWARE_MANAGEMENT": {
    "APP": "Hardware",
    "TITLE": "Hardware-Verwaltung",
    "FILTER": "Alle",
    "MENU": {
      "OVERVIEW": "Hardware-Liste",
      "CREATE": "Neue Hardware",
      "SEARCH": "Abfrage"
    },
    "FORM": {
      "ACTIONS": {
        "RESET": "Zurücksetzen",
        "SAVE": "Speichern",
        "CANCEL": "Abbrechen",
        "EDIT": "Editieren",
        "CREATE": "Erstellen"
      },
      "COMMON": {
        "BESCHREIBUNG": "Beschreibung",
        "BEZEICHNUNG": "Bezeichnung"
      },
      "ID": {
        "LABEL": "Id",
        "PLACEHOLDER": "Id"
      },
      "KUNDE": {
        "LABEL": "Kunde",
        "PLACEHOLDER": "Kunde"
      },
      "BENUTZER": {
        "LABEL": "Benutzer",
        "PLACEHOLDER": "Benutzer"
      },
      "SERIENNUMMER": {
        "LABEL": "Seriennummer",
        "PLACEHOLDER": "Seriennummer"
      },
      "ARBEITSGRUPPE": {
        "LABEL": "Arbeitsgruppe",
        "PLACEHOLDER": "Arbeitsgruppe"
      },
      "KTOSTAMM_STANDORT": {
        "LABEL": "Kunde Standort",
        "PLACEHOLDER": "Kunde Standort"
      },
      "STANDORT": {
        "LABEL": "Standort",
        "PLACEHOLDER": "Standort"
      },
      "DOMAIN": {
        "LABEL": "Domäne",
        "PLACEHOLDER": "Domäne"
      },
      "SOFTLINEID": {
        "LABEL": "Softline-ID",
        "PLACEHOLDER": "Auto-ID"
      },
      "IP_STATISCH": {
        "LABEL": "IP Statisch"
      },
      "IP_DHCP": {
        "LABEL": "IP DHCP"
      },
      "IP_DHCP_RESERVIERUNG": {
        "LABEL": "IP DHCP-Reservierung"
      },
      "MAC_ADRESSE": {
        "LABEL": "MAC Adresse",
        "PLACEHOLDER": "MAC Adresse"
      },
      "IP_ADRESSE": {
        "LABEL": "IP Adresse",
        "PLACEHOLDER": "IP Adresse"
      },
      "GATEWAY": {
        "LABEL": "Gateway",
        "PLACEHOLDER": "Gateway"
      },
      "DNS1": {
        "LABEL": "DNS 1",
        "PLACEHOLDER": "DNS 1"
      },
      "DNS2": {
        "LABEL": "DNS 2",
        "PLACEHOLDER": "DNS 2"
      },
      "LIZENZKEY": {
        "LABEL": "Lizenz",
        "PLACEHOLDER": "Lizenz / Schlüssel"
      },
      "TEAMVIEWER_ID": {
        "LABEL": "Teamviewer-ID",
        "PLACEHOLDER": "Teamviewer-ID"
      },
      "TEAMVIEWER_PW": {
        "LABEL": "Teamviewer Passwort",
        "PLACEHOLDER": "Teamviewer Passwort"
      },
      "LIEFERDATUM": {
        "LABEL": "Lieferdatum",
        "PLACEHOLDER": "Lieferdatum"
      },
      "AUSSCHEIDEDATUM": {
        "LABEL": "Ausscheidedatum",
        "PLACEHOLDER": "Ausscheidedatum"
      },
      "SERVICE_TAG": {
        "LABEL": "Service Tag",
        "PLACEHOLDER": "Service Tag"
      },
      "EXPRESS_SERVICE_TAG": {
        "LABEL": "Express Service Tag",
        "PLACEHOLDER": "Express Service Tag"
      },
      "GARANTIETYP": {
        "LABEL": "Garantie-Typ",
        "PLACEHOLDER": "Garantie-Typ"
      },
      "SUPPORTTYP": {
        "LABEL": "Support-Typ",
        "PLACEHOLDER": "Support-Typ"
      },
      "SUBNETZMASKE": {
        "LABEL": "Subnetzmaske",
        "PLACEHOLDER": "Subnetzmaske"
      },
      "BETRIEBSSYSTEM": {
        "LABEL": "Betriebssystem",
        "PLACEHOLDER": "Betriebssystem"
      },
      "HERSTELLER": {
        "LABEL": "Hersteller",
        "PLACEHOLDER": "Hersteller",
        "GLN_LABEL": "GLN"
      },
      "PRODUKT": {
        "LABEL": "Produkt",
        "PLACEHOLDER": "Produkt"
      },
      "HOSTNAME": {
        "LABEL": "Hostname",
        "PLACEHOLDER": "Hostname"
      },
      "HARDWARETYP": {
        "LABEL": "Hardware-Typ",
        "PLACEHOLDER": "Hardware-Typ"
      }
    },
    "PAGES": {
      "RESULTS": {
        "TITLE": "Hardware-Verwaltung",
        "DETAIL_PLACEHOLDER": "Bitte wählen Sie eine Hardware aus der Liste um die Details anzusehen.",
        "DETAIL_DATA": "Daten",
        "DETAIL_COMMENTS": "Kommentare",
        "DETAIL_NO_COMMENTS": "Es gibt noch keine Kommentare für diesen Hardware-Eintrag"
      },
      "CREATE": {
        "TITLE": "Hardware anlegen",
        "ACTION": "Anlegen"
      },
      "QUERY": {
        "TITLE": "Hardware suchen",
        "ACTION": "Suchen",
        "OPTIONAL_FILTERS": "Optionale Einschränkungen"
      }
    },
    "DIALOGS": {
      "CANCEL_EDITING": {
        "TEXT": "Alle Änderung werden verworfen. Wollen Sie die Eingabe wirklich abbrechen?",
        "TITLE": "Abbrechen?"
      }
    },
    "MESSAGES": {
      "UPDATE_HARDWARE_SUCCESS": "Hardware wurde erfolgreich aktualisiert und gespeichert!",
      "CREATE_HARDWARE_SUCCESS": "Hardware wurde erfolgreich erstellt und gespeichert!"
    }
  }
}
